import { Text } from "@minervaproject/fds";
import { sortBy } from "lodash";

import { PollType } from "shared/types";
import { numberToLetter } from "utils/string";

function PollChoices({ poll }: { poll: PollType }) {
  const choices = sortBy(poll.poll_choices, "index");
  return (
    <div className="pb4">
      {choices.map((choice) => (
        <div key={choice.id} className="flex mb2" data-testid="choice">
          <Text bold mr={2}>
            {numberToLetter(choice.index)}.
          </Text>
          <Text>{choice.choice}</Text>
        </div>
      ))}
    </div>
  );
}

export { PollChoices };
